import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const SectionTitle = ({ eyebrow, title, desc, more, moreLabel = "Lihat Selengkapnya", moreTestId }) => {
  const block = (
    <div className="max-w-2xl">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-emerald-700">{eyebrow}</p>
      <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-emerald-950">{title}</h2>
      <div className="mt-3 h-1 w-16 rounded-full gold-line" />
      {desc && <p className="mt-4 text-base text-slate-600 leading-relaxed">{desc}</p>}
    </div>
  );
  if (!more) return block;
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      {block}
      <Link to={more} className="inline-flex items-center gap-2 rounded-full border border-emerald-900/15 px-5 py-2.5 text-sm font-semibold text-emerald-900 hover:bg-emerald-50 transition-colors" data-testid={moreTestId}>
        {moreLabel} <ArrowRight size={15} />
      </Link>
    </div>
  );
};
